import { useEffect, useState } from 'react';
import { useToast } from '@/components/feature/ToastProvider';

const navItems = [
  { label: '首页', href: '#top' },
  { label: '今日新瓜', href: '#today' },
  { label: '事件时间线', href: '#timeline' },
  { label: '滚动爆料', href: '#rolling' },
  { label: '社区热议', href: '#community' },
  { label: '吃瓜须知', href: '#faq' },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const { showToast } = useToast();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSearch = () => {
    showToast(keyword.trim() ? `演示环境：正在检索「${keyword.trim()}」` : '演示环境：请输入想找的话题');
  };

  const handleSubmitTip = () => {
    showToast('演示环境：爆料入口暂未开放提交');
  };

  const headerTone = scrolled || menuOpen
    ? 'bg-background-50/95 border-background-200/80 backdrop-blur'
    : 'bg-transparent border-transparent';
  const textTone = scrolled || menuOpen ? 'text-foreground-950' : 'text-background-50';

  return (
    <header className={`fixed inset-x-0 top-0 z-[70] border-b transition-colors duration-300 ${headerTone}`}>
      <div className="mx-auto flex h-16 w-full max-w-shell items-center justify-between gap-6 px-4 md:h-[72px] md:px-6">
        <a href="#top" className={`flex items-center gap-2.5 ${textTone}`}>
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-line text-lg" />
          </span>
          <h1 className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight">黑料在线</span>
            <span className="mt-0.5 text-[10px] font-normal tracking-[0.2em] opacity-70">24H ROLLING</span>
          </h1>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${textTone} ${
                scrolled || menuOpen ? 'hover:bg-background-200/70' : 'hover:bg-background-50/15'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setSearchOpen((prev) => !prev)}
            aria-label="搜索话题"
            className={`flex h-9 w-9 items-center justify-center rounded-md transition-colors ${textTone} ${
              scrolled || menuOpen ? 'hover:bg-background-200/70' : 'hover:bg-background-50/15'
            }`}
          >
            <i className={searchOpen ? 'ri-close-line text-lg' : 'ri-search-line text-lg'} />
          </button>
          <button
            type="button"
            onClick={handleSubmitTip}
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:flex"
          >
            我要爆料
          </button>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="打开菜单"
            className={`flex h-9 w-9 items-center justify-center rounded-md transition-colors lg:hidden ${textTone} ${
              scrolled || menuOpen ? 'hover:bg-background-200/70' : 'hover:bg-background-50/15'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'} />
          </button>
        </div>
      </div>

      {searchOpen && (
        <div className="mx-auto w-full max-w-shell px-4 pb-3 md:px-6">
          <div className="flex items-center gap-2 rounded-md border border-background-300/70 bg-background-100 px-3">
            <i className="ri-search-line text-base text-foreground-500" />
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  handleSearch();
                }
              }}
              placeholder="搜索今日新瓜、话题标签或爆料关键词"
              className="h-11 w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
            />
            <button
              type="button"
              onClick={handleSearch}
              className="whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              检索
            </button>
          </div>
        </div>
      )}

      {menuOpen && (
        <div className="border-t border-background-200/80 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between rounded-md px-3 py-3 text-sm text-foreground-800 transition-colors hover:bg-background-200/70"
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-base text-foreground-400" />
              </a>
            ))}
          </nav>
          <button
            type="button"
            onClick={handleSubmitTip}
            className="mt-2 w-full whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            我要爆料
          </button>
        </div>
      )}
    </header>
  );
}